export default __webpack_public_path__ + "static/media/Cool Rock Full.bb7ce4e3.mp3";